
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#C3AFA3","d":"M11.25 4.75h-.931a4.478 4.478 0 00-.382-.92l.659-.658a.75.75 0 000-1.061l-.707-.707a.75.75 0 00-1.061 0l-.659.659c-.291-.161-.6-.29-.919-.382V.75A.75.75 0 006.5 0h-1a.75.75 0 00-.75.75v.931c-.32.093-.628.221-.92.382l-.659-.659a.75.75 0 00-1.06 0l-.708.708a.75.75 0 000 1.06l.66.659c-.162.291-.29.6-.382.919H.75A.75.75 0 000 5.5v1c0 .414.336.75.75.75h.931c.092.32.22.628.381.92l-.659.659a.75.75 0 000 1.06l.707.708a.772.772 0 001.061 0l.659-.659c.292.161.6.29.92.382v.93c0 .414.336.75.75.75h1a.75.75 0 00.75-.75v-.93c.32-.093.628-.22.92-.382l.659.659a.75.75 0 001.06 0l.707-.707a.75.75 0 000-1.06l-.659-.659c.162-.291.29-.6.382-.92h.931A.75.75 0 0012 6.5v-1a.75.75 0 00-.75-.75zM6 8.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"}})])
          )
        }
      }
    